import request from "superagent";

interface GraphQLResponse<T> {
  data: T;
  errors?: { message: string }[];
}

export default async function srsGraphqlRequest<T>(
  query: string,
  variables: Record<string, any>
): Promise<T> {
  const baseUrl = process.env.STUDENT_RECORD_STORE_URL;
  if (!baseUrl) {
    throw new Error("STUDENT_RECORD_STORE_URL is not defined");
  }
  const response = await request
    .post(baseUrl)
    .set("x-api-key", process.env.STUDENT_RECORD_STORE_KEY!)
    .set("Content-Type", "application/json")
    .send({ query, variables });

  const { body } = response;

  if (body.errors) {
    console.log(body.errors);
    throw new Error(body.errors[0].message);
  }

  return body.data;
}
